import { render, staticRenderFns } from "./feeDetailSub.vue?vue&type=template&id=03c27570&scoped=true"
import script from "./feeDetailSub.vue?vue&type=script&lang=js"
export * from "./feeDetailSub.vue?vue&type=script&lang=js"
import style0 from "./feeDetailSub.vue?vue&type=style&index=0&id=03c27570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c27570",
  null
  
)

export default component.exports